// External libraries
import gql from 'graphql-tag';

export const ADDRESS_AUTOCOMPLETE_QUERY = gql`
  query AddressAutocompleteQuery(
    $count: Int
    $countries: [CountryCodes]
    $input: String!
    $language: CheckoutContentLanguageCode
    $location: GeoLocation
    $radius: Int
    $sessionId: String!
  ) {
    addressAutoComplete(
      count: $count
      countries: $countries
      input: $input
      language: $language
      location: $location
      radius: $radius
      sessionId: $sessionId
    ) {
      suggestions {
        addressText
        mainText
        placeId
        secondaryText
      }
    }
  }
`;
